import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

export default function VerticalizedTables(props) {
  const classes = useStyles();
  const tableInput = props.tableInput;
  const tableFlagments = tableInput.map(row => (
    <>
      <TableRow key={row.logicalName}>
        <TableCell style={row.style}>{row.logicalName}</TableCell>
        <TableCell style={row.style}>{row.value}</TableCell>
        <TableCell style={row.style}>{row.note}</TableCell>
      </TableRow>
    </>
  ));

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        {tableInput.length > 0 ? (
          <>
            <TableHead style={{ backgroundColor: "#3f51b5" }}>
              <TableRow>
                <TableCell style={{ color: "#fff" }}>項目</TableCell>
                <TableCell style={{ color: "#fff" }}>値</TableCell>
                <TableCell style={{ color: "#fff" }}>備考</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tableFlagments}</TableBody>
          </>
        ) : (
          ""
        )}
      </Table>
    </TableContainer>
  );
}
